import type { FuriganaSegment } from "../../shared/schema";

export function FuriganaText({ segments }: { segments?: FuriganaSegment[] }) {
  return (
    <span lang="ja" className="furigana-text">
      {(segments ?? []).map((segment, index) =>
        segment.reading ? (
          <ruby key={`${segment.text}-${index}`}>
            {segment.text}<rt>{segment.reading}</rt>
          </ruby>
        ) : (
          <span key={`${segment.text}-${index}`}>{segment.text}</span>
        ),
      )}
    </span>
  );
}
